// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ThirdPartyLogController = function ($scope, $routeParams, ThirdPartyRequests) {

    $scope.filter = {
        search: "",
        after: moment().subtract(1, 'days').toISOString(true),
        before: moment().toISOString(true),
        thirdPartyIntegration: ""
     };

    $scope.loadThirdPartyRequests = function () {
        $scope.thirdPartyRequests = 
             $scope.paginator(function(options, callback) {
            return ThirdPartyRequests.query(options, function() { callback(); });
        },
        {
            search: $scope.filter.search,
            before: $scope.filter.before,
            after: $scope.filter.after,
            thirdPartyIntegration: $scope.filter.thirdPartyIntegration
        },
        100);
    }


    $scope.loadThirdPartyRequests();
};
ThirdPartyLogController.$inject = [ '$scope', '$routeParams', 'ThirdPartyRequests']; 
